export default {"src":"/_next/static/media/logo-autopass.3e63e7a2.svg","height":15,"width":70,"blurWidth":0,"blurHeight":0};